import apiClient, { jsonRequestConfig } from "./httpClient";
import endpoints from "./endpoints";

export const authApi = {
  me: () => apiClient.get(endpoints.auth.me()),
  login: (email, password) =>
    apiClient.post(endpoints.auth.login(), { email, password }, jsonRequestConfig),
  logout: (fcmToken) =>
    apiClient.post(
      endpoints.auth.logout(),
      fcmToken ? { fcmToken } : {},
      jsonRequestConfig
    ),
  signup: ({ email, name, application }) =>
    apiClient.post(
      endpoints.auth.signup(),
      { email, name, application: String(application || "").trim() || undefined },
      jsonRequestConfig
    ),
  verifyCode: ({ email, code, password, application }) =>
    apiClient.post(
      endpoints.auth.verifyCode(),
      {
        email,
        code,
        password,
        application: String(application || "").trim() || undefined,
      },
      jsonRequestConfig
    ),
  forgotPassword: (email) =>
    apiClient.post(endpoints.auth.forgotPassword(), { email }, jsonRequestConfig),
  verifyResetCode: (email, code) =>
    apiClient.post(endpoints.auth.verifyResetCode(), { email, code }, jsonRequestConfig),
  resetPassword: (password) =>
    apiClient.post(endpoints.auth.resetPassword(), { password }, jsonRequestConfig),
};

export default authApi;
